<template>
  <b-card v-if="notes.length">
    <h5 class="mb-2">History with {{ employeeName }}</h5>

    <div
      v-for="(note, index) in notes"
      :key="note.hashid"
      class="history-preview-item"
      :class="index == 0 ? '' : 'mt-1 pt-1 border-top'"
    >
      <div class="d-flex justify-content-between align-items-start">
        <h6 v-if="note.title" class="mb-0 text-truncate mr-1">{{ note.title }}</h6>
        <small class="text-muted ml-auto text-nowrap">{{ formatDate(note.noted_at) }}</small>
      </div>
      <div v-if="note.tags && note.tags.length" class="mt-25">
        <b-badge
          v-for="tag in note.tags.slice(0, 3)"
          :key="tag"
          pill
          variant="light-primary"
          class="mr-50 mb-25"
        >
          {{ tag }}
        </b-badge>
        <small v-if="note.tags.length > 3" class="text-muted">+{{ note.tags.length - 3 }} more</small>
      </div>
      <p class="mb-0 mt-25 small text-muted">{{ snippet(note.content) }}</p>
    </div>

    <b-button
      variant="outline-primary"
      size="sm"
      block
      class="mt-2"
      :to="{ name: 'history-with-employee', params: { employeeId } }"
      target="_blank"
    >
      View All
    </b-button>
  </b-card>
</template>

<script>
import { BCard, BButton, BBadge } from "bootstrap-vue";
import axios from "@axios";

export default {
  name: "ProfileHistoryWithEmployee",
  components: { BCard, BButton, BBadge },
  props: {
    employeeId: { type: String, required: true },
    employeeName: { type: String, default: "" },
  },
  data() {
    return {
      notes: [],
    };
  },
  watch: {
    employeeId: {
      immediate: true,
      handler(val) {
        if (val) this.fetchPreview();
      },
    },
  },
  methods: {
    fetchPreview() {
      axios
        .get(`/personal-notes/history/${this.employeeId}`, { params: { per_page: 5 } })
        .then((res) => {
          this.notes = res.data.data;
        })
        .catch(() => {
          this.notes = [];
        });
    },
    formatDate(value) {
      if (!value) return "";
      return new Date(value).toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
    snippet(html) {
      if (!html) return "";
      const text = html.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
      return text.length > 140 ? `${text.slice(0, 140)}...` : text;
    },
  },
};
</script>
